// extracted by mini-css-extract-plugin
export default {"App":"App_App__yWcf8"};